/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reports_Col_Case_ValueInputs */

const en_reports_col_case_value = /** @type {(inputs: Reports_Col_Case_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Case value`)
};

const pt_br2_reports_col_case_value = /** @type {(inputs: Reports_Col_Case_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valor Caso`)
};

/**
* | output |
* | --- |
* | "Case value" |
*
* @param {Reports_Col_Case_ValueInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const reports_col_case_value = /** @type {((inputs?: Reports_Col_Case_ValueInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reports_Col_Case_ValueInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reports_col_case_value(inputs)
	return pt_br2_reports_col_case_value(inputs)
});